var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "confirmation1a") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "confirmation1a",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "confirmation",
    fill: "#239FB5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.0668,6.5137 L12.4538,6.5137 C12.9038,6.5137 13.2678,6.1497 13.2678,5.7007 C13.2678,5.2497 12.9038,4.8857 12.4538,4.8857 L4.0668,4.8857 C3.6178,4.8857 3.2528,5.2497 3.2528,5.7007 C3.2528,6.1497 3.6178,6.5137 4.0668,6.5137 M19.642,13.123 L14.111,19.295 L10.723,16.063 C10.434,15.788 10.422,15.329 10.698,15.04 C10.973,14.751 11.43,14.738 11.719,15.014 L11.72,15.015 L14.03,17.218 L18.567,12.154 C18.833,11.857 19.289,11.833 19.586,12.099 C19.586,12.1 19.587,12.1 19.587,12.1 C19.884,12.367 19.909,12.825 19.642,13.123 M7.939,19.217 L3.257,19.217 C2.359,19.217 1.628,18.486 1.628,17.588 L1.628,3.257 C1.628,2.359 2.359,1.629 3.257,1.629 L13.268,1.629 C14.166,1.629 14.897,2.359 14.897,3.257 L14.897,7.197 C13.606,7.229 12.39,7.563 11.324,8.143 L4.067,8.143 C3.618,8.143 3.252,8.507 3.252,8.957 C3.252,9.406 3.618,9.771 4.067,9.771 L9.259,9.771 C8.811,10.263 8.42,10.807 8.106,11.399 L4.067,11.399 C3.618,11.399 3.252,11.765 3.252,12.214 C3.252,12.664 3.618,13.028 4.067,13.028 L7.469,13.028 C7.291,13.687 7.188,14.378 7.188,15.094 C7.188,16.7 7.669,18.192 8.493,19.44 C8.347,19.304 8.155,19.217 7.939,19.217 M16.525,7.323 L16.525,3.257 C16.525,1.461 15.064,0 13.268,0 L3.257,0 C1.461,0 0,1.461 0,3.257 L0,17.588 C0,19.384 1.461,20.845 3.257,20.845 L7.939,20.845 C8.389,20.845 8.753,20.48 8.753,20.031 C8.753,19.92 8.731,19.814 8.69,19.718 C10.126,21.703 12.456,23 15.094,23 C19.46,23 23,19.46 23,15.094 C23,11.217 20.207,7.998 16.525,7.323",
    id: "Fill-16"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmation);
export default __webpack_public_path__ + "static/media/confirmation.97a3a59a9613edbce6cb168350c7e0ff.svg";
export { ForwardRef as ReactComponent };